// src/components/nodes/NodeManager.js
import { CustomNode } from './CustomNode';
import { OrgChartNode } from './OrgChartNode';
import { EntityNode } from './EntityNode';
import { DecisionNode } from './DecisionNode';
import { TextNode } from './TextNode';
import { DocumentNode } from './DocumentNode';
import { NoteNode } from './NoteNode';

/**
 * 节点管理器 - 统一管理所有节点类型
 */
export class NodeManager {
  constructor() {
    this.nodeClasses = new Map();
    this.registerDefaultNodes();
  }

  /**
   * 注册默认节点类型
   */
  registerDefaultNodes() {
    this.registerNode('custom', CustomNode);
    this.registerNode('org', OrgChartNode);
    this.registerNode('entity', EntityNode);
    this.registerNode('decision', DecisionNode);
    this.registerNode('text', TextNode);
    this.registerNode('document', DocumentNode);
    this.registerNode('note', NoteNode);
  }

  /**
   * 注册新节点类型
   */
  registerNode(type, NodeClass) {
    this.nodeClasses.set(type, NodeClass);
  }

  /**
   * 获取所有节点类型的配置信息
   */
  getAllNodeConfigs() {
    const configs = [];
    for (const [type, NodeClass] of this.nodeClasses.entries()) {
      const nodeInstance = new NodeClass();
      configs.push(nodeInstance.getConfig());
    }
    return configs;
  }

  /**
   * 获取节点类型的React组件
   */
  getNodeComponents(customProps = {}) {
    const components = {};
    for (const [type, NodeClass] of this.nodeClasses.entries()) {
      const nodeInstance = new NodeClass();
      components[type] = nodeInstance.createComponent(customProps);
    }
    return components;
  }

  /**
   * 根据类型获取节点配置
   */
  getNodeConfig(type) {
    const NodeClass = this.nodeClasses.get(type);
    if (!NodeClass) return null;
    
    const nodeInstance = new NodeClass();
    return nodeInstance.getConfig();
  }

  /**
   * 获取特定节点的默认数据
   */
  getDefaultData(type) {
    const NodeClass = this.nodeClasses.get(type);
    if (!NodeClass) return {};
    
    const nodeInstance = new NodeClass();
    return nodeInstance.defaultData;
  }

  /**
   * 检查节点类型是否存在
   */
  hasNodeType(type) {
    return this.nodeClasses.has(type);
  }
}

// 创建单例实例
export const nodeManager = new NodeManager();

// 导出所有节点类型供单独使用
export { 
  CustomNode, 
  OrgChartNode, 
  EntityNode, 
  DecisionNode, 
  TextNode, 
  DocumentNode, 
  NoteNode 
};